module.exports = __webpack_public_path__ + "static/media/6.33325551.JPG";